<main>
    <router-outlet></router-outlet>
</main>


<!-- 태블릿 이상 접속시 안내 메시지 -->
<!-- <section class="device-guide is-hidden-mobile">
    <h1>기후위기오다 페이지를 찾으셨나요? <br />모바일로 접속해주세요 🙏🏼</h1>
</section> -->